<template>
  <button-dialog-container
    :btn-icon="icon"
    :size="getSize"
    :only-icon="true"
    :dialog-viewer.sync="dialog"
    :no-tool-tip="noToolTip"
    :width-dialog="getWidth"
    :title-tool-tip="titleToolTip"
    @ok-pushed="openFile"
    @cancel-pushed="outsideClick"
    @outside-click="outsideClick"
  >
    <v-container class="pa-0 pt-4">
      <v-row>
        <v-col
          v-if="currentFile.name != 'none'"
          class="d-flex text-center justify-center align-center"
          cols="4"
        >
          <!-- IF MIME TYPE INCLUDES VIDEO -->
          <video
            v-if="currentFile.mime.includes('video')"
            :key="currentFile.name"
            width="100%"
            height="100%"
            controls
            muted
          >
            <!-- IF FILE EXTENSION IS MP4 -->
            <source
              v-if="currentFile.ext.includes('mp4')"
              :src="source"
              type="video/mp4"
            />
            <!-- IF FILE EXTENSION IS WEBM -->
            <source
              v-if="currentFile.ext.includes('webm')"
              :src="source"
              type="video/webm"
            />
          </video>
          <!-- IF MIME TYPE INCLUDES IMAGE -->
          <v-img
            v-if="currentFile.mime.includes('image')"
            class="text-center justify-center align-center"
            contain
            max-width="100%"
            max-height="100%"
            :lazy-src="source"
            :src="source"
          />
        </v-col>
        <v-col :cols="currentFile.name != 'none' ? 8 : 12">
          <file-explorer
            :dir="currentPath"
            :filter="cFileFilter"
            :reset="reset"
            :selectable="cSelectable"
            :activatable="cActivatable"
            @item-selected="itemSelected"
          />
          <v-btn
            v-if="sharedMedia"
            id="btnShare"
            absolute
            fab
            small
            @click="toggleShare()"
          >
            <v-icon>mdi-share-variant</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </button-dialog-container>
</template>

<script>
// Components
import buttonDialogContainer from "../Common/ButtonDialogContainer";
import fileExplorer from "../Common/FileExplorer";

export default {
  components: {
    buttonDialogContainer,
    fileExplorer,
  },
  props: {
    currentObject: {
      type: Object,
      default: () => {},
    },
    icon: {
      type: String,
      default: "",
    },
    fileFilter: {
      type: Array,
      default: () => [],
    },
    selectable: {
      type: Boolean,
      default: true,
    },
    activatable: {
      type: Boolean,
      default: false,
    },
    toolName: {
      type: String,
      default: "",
    },
    titleToolTip: {
      type: String,
      default: "",
    },
    noToolTip: {
      type: Boolean,
      default: true,
    },
    getSize: {
      type: Number,
      default: 25,
    },
    sharedMedia: {
      type: Boolean,
      default: false,
    },
    sizeProject: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dblclick: false,
      dialog: false,
      files: [],
      filter: "",
      currentPath: "",
      mediacenterPath: "",
      sharePath: "",
      name: "",
      pathFile: "",
      reset: false,
    };
  },
  computed: {
    currentFile() {
      if (this.files.length > 0) {
        return this.files[0];
      } else {
        return {
          name: "none",
          ext: "none",
          mime: "none",
        };
      }
    },
    getWidth() {
      if (this.cFileFilter.includes(".pdf")) {
        return 0;
      } else {
        return 800;
      }
    },
    cActivatable() {
      switch (this.name) {
        case "image":
          return false;
        case "video":
          return true;
        case "pdf":
          return true;

        default:
          return this.activatable;
      }
    },
    cSelectable() {
      switch (this.name) {
        case "image":
          return true;
        case "video":
          return false;
        case "pdf":
          return false;
        default:
          return this.selectable;
      }
    },
    cFileFilter() {
      if (this.filter != "") {
        return this.filter;
      } else {
        return this.fileFilter;
      }
    },
    source() {
      if (this.pathFile != "") {
        return this.pathFile;
      } else {
        return "";
      }
    },
    open() {
      return this.$store.state.widget.openEditImage || this.$store.state.widget.openEditVideo;
    },
  },
  watch: {
    open: function () {
      if (this.open) {
        if (this.$store.state.widget.openEditImage) {
          this.name = "image";
          this.filter = [".bmp", ".gif", ".jpeg", ".jpg", ".png", ".svg"];
        }

        if (this.$store.state.widget.openEditVideo) {
          this.name = "video";
          this.filter = [".mp4", ".webm"];
        }

        this.dialog = true;
        this.dblclick = true;
        this.$store.dispatch("editClose").widget;
      }
    },
  },
  created() {
    this.mediacenterPath = this.$store.state.config.dirs.root + "mediacenter/" + this.$store.state.user.socId;

    // If dir limited for user we use this root path
    if (this.$store.state.user.dir != "") {
      this.mediacenterPath = this.$store.state.user.dir;
    }

    this.sharePath = this.$store.state.config.dirs.root + "mediacenter/share";

    this.currentPath = this.mediacenterPath;
    this.explorerSelection = [this.currentPath];
  },
  methods: {
    itemSelected: function (val) {
      this.pathFile = "";

      // Array containing selected files
      if (val.length > 0) {
        this.pathFile = val[val.length - 1].path.split("\\").join("/");
      }
      this.files = val;
    },
    itemSelect: function (val) {
      this.pathFile = "";
      this.files = [];

      // Object containing selected file
      if (val !== undefined) {
        this.pathFile = val.path.split("\\").join("/");
        this.files = [val];
      }
    },
    openFile() {
      if (this.files.length > 0) {
        if (!this.dblclick) {
          if (this.toolName) {
            this.$emit("toolSelectedFromDialog", this.toolName);
          }
          this.$emit(
            "fileSelected",
            this.files.map((file) => file.path)
          );
        } else if (this.dblclick) {
          this.$emit("editElement", {
            name: this.name,
            content: this.files.map((file) => file.path),
            config: this.currentObject.konvaObjectOption,
          });
          this.dblclick = false;
        }
        this.reset = !this.reset;
        this.filter = "";
        this.name = "";
        this.files = [];
      }
    },
    outsideClick() {
      this.reset = !this.reset;
      this.filter = "";
      this.files = [];
    },
    toggleShare() {
      if (this.currentPath == this.mediacenterPath) {
        this.currentPath = this.sharePath;
      } else {
        this.currentPath = this.mediacenterPath;
      }

      this.explorerSelection = [this.currentPath];
      this.reset = !this.reset;
    },
  },
};
</script>

<style>
#btnShare {
  bottom: 60px;
  right: 5px;
}
</style>
